import Profile from "../components/events/eventDetails/event"
import Nav from "../components/Nav/nav";

const ProfPage = () => {
  return (
    <div>
      <Nav />
      <Profile />
    </div>
  );
};

export default ProfPage;
